/* wsapi3-signup-page v1.0 */
/* Deploy Version 2026-09-25 09:33:14 */
/* Deploy Version 2026-09-24 19:11:14 */
/* Deploy Version 2026-07-27 16:11:03 */
(function () {
    'use strict';

    var _signupProfileId = null;

    /* ═══════════════════════════════════════════════════════
       HELPERS
    ═══════════════════════════════════════════════════════ */
    function el(id) { return document.getElementById(id); }

    function setMsg(id, text, type) {
        var div = el(id);
        if (!div) return;
        div.textContent = text || '';
        div.className = 'field-msg' + (type ? ' field-msg--' + type : '');
    }

    function clearMsg(id) { setMsg(id, '', ''); }

    function setLoading(btnId, loading) {
        var btn = el(btnId);
        if (!btn) return;
        btn.disabled = loading;
        if (loading) {
            btn.dataset._origText = btn.dataset._origText || btn.firstChild.textContent.trim();
            btn.firstChild.textContent = 'Aguarde... ';
        } else {
            if (btn.dataset._origText) btn.firstChild.textContent = btn.dataset._origText + ' ';
        }
    }

    function onlyDigits(str) {
        return (str || '').replace(/\D/g, '');
    }

    function setValue(id, val) {
        var inp = el(id);
        if (inp) {
            inp.value = val || '';
            if (inp.value) clearFieldError(inp);
        }
    }

    function parseDateInput(val) {
        if (!val) return '';
        var parts = val.split('/');
        if (parts.length === 3 && parts[2].length === 4) {
            return parts[2] + '-' + parts[1] + '-' + parts[0];
        }
        return '';
    }

    /* ═══════════════════════════════════════════════════════
       ALTERNÂNCIA DE TIPO DE PESSOA
    ═══════════════════════════════════════════════════════ */
    var typeF = el('js-sg-type-f');
    var typeJ = el('js-sg-type-j');
    var cpfWrap = el('js-sg-cpf-wrap');
    var cnpjWrap = el('js-sg-cnpj-wrap');

    function updatePersonType() {
        var isF = typeF && typeF.checked;
        if (cpfWrap) cpfWrap.classList.toggle('hidden', !isF);

        var razaoWrap = el('js-sg-razao-wrap');
        if (razaoWrap) razaoWrap.classList.toggle('hidden', isF);
        if (cnpjWrap) cnpjWrap.classList.toggle('hidden', isF);

        // Atualiza visual do toggle (fallback para browsers sem :has())
        document.querySelectorAll('.person-type-option').forEach(function (opt) {
            var radio = opt.querySelector('input[type="radio"]');
            if (radio) opt.classList.toggle('selected', radio.checked);
        });
    }

    if (typeF) typeF.addEventListener('change', updatePersonType);
    if (typeJ) typeJ.addEventListener('change', updatePersonType);
    updatePersonType(); // estado inicial

    /* ═══════════════════════════════════════════════════════
       VALIDAÇÃO VISUAL DE CAMPO (check-signup)
    ═══════════════════════════════════════════════════════ */
    function setFieldCheck(inputId, iconId, msgId, state, msg) {
        var inp = el(inputId);
        var icon = el(iconId);
        var msgEl = el(msgId);
        if (!inp) return;
        if (!msgEl && state === 'error') {
            msgEl = document.createElement('div');
            msgEl.id = msgId;
            inp.closest('.field-group').appendChild(msgEl);
        }
        if (msgEl) {
            var describedBy = (inp.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
            if (describedBy.indexOf(msgId) === -1) describedBy.push(msgId);
            inp.setAttribute('aria-describedby', describedBy.join(' '));
            msgEl.setAttribute('aria-live', 'polite');
        }

        inp.classList.remove('field-input--valid', 'field-input--error');
        if (state === 'error') inp.setAttribute('aria-invalid', 'true');
        else inp.removeAttribute('aria-invalid');
        if (icon) icon.classList.add('hidden');
        if (msgEl) { msgEl.textContent = ''; msgEl.className = 'field-inline-msg'; }

        if (state === 'valid') {
            inp.classList.add('field-input--valid');
            if (icon) icon.classList.remove('hidden');
        } else if (state === 'error') {
            inp.classList.add('field-input--error');
            if (msgEl) {
                msgEl.textContent = msg || '';
                msgEl.className = 'field-inline-msg field-inline-msg--error';
            }
        }
    }

    function setFieldError(inputId, message) {
        setFieldCheck(inputId, inputId + '-icon', inputId + '-vmsg', 'error', message);
    }

    function clearFieldError(inp) {
        if (inp && inp.classList.contains('field-input--error')) {
            setFieldCheck(inp.id, inp.id + '-icon', inp.id + '-vmsg', 'reset', '');
        }
    }

    document.querySelectorAll('.signup-block-page .field-input, .signup-block-page .field-select').forEach(function (inp) {
        inp.addEventListener('input', function () { clearFieldError(inp); });
        inp.addEventListener('change', function () { clearFieldError(inp); });
    });

    function focusFirstError(step) {
        var first = step && step.querySelector('.field-input--error');
        if (first) first.focus();
    }

    function applyCheckResult(field, result, inputId, iconId, msgId) {
        if (!result) return;
        // 1º: formato/dígitos inválidos
        if (!result.valid) {
            setFieldCheck(inputId, iconId, msgId, 'error',
                field === 'email' ? 'E-mail inválido.' : 'Documento inválido.');
            return;
        }
        // 2º: válido mas já existe — verificado independentemente do valid
        if (result.exists) {
            setFieldCheck(inputId, iconId, msgId, 'error',
                field === 'email'
                    ? 'Este e-mail já está cadastrado nesta loja.'
                    : 'Este documento já está cadastrado nesta loja.');
            return;
        }
        // 3º: tudo certo
        setFieldCheck(inputId, iconId, msgId, 'valid', '');
    }

    /* ═══════════════════════════════════════════════════════
       MÁSCARAS DE ENTRADA
    ═══════════════════════════════════════════════════════ */

    // CPF: 000.000.000-00
    var cpfInput = el('js-sg-cpf');
    if (cpfInput) {
        cpfInput.addEventListener('input', function () {
            var d = onlyDigits(cpfInput.value).substring(0, 11);
            if (d.length <= 3) cpfInput.value = d;
            else if (d.length <= 6) cpfInput.value = d.substring(0, 3) + '.' + d.substring(3);
            else if (d.length <= 9) cpfInput.value = d.substring(0, 3) + '.' + d.substring(3, 6) + '.' + d.substring(6);
            else cpfInput.value = d.substring(0, 3) + '.' + d.substring(3, 6) + '.' + d.substring(6, 9) + '-' + d.substring(9);
        });
    }

    // CNPJ: 00.000.000/0000-00
    var cnpjInput = el('js-sg-cnpj');
    if (cnpjInput) {
        cnpjInput.addEventListener('input', function () {
            var d = onlyDigits(cnpjInput.value).substring(0, 14);
            if (d.length <= 2) cnpjInput.value = d;
            else if (d.length <= 5) cnpjInput.value = d.substring(0, 2) + '.' + d.substring(2);
            else if (d.length <= 8) cnpjInput.value = d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5);
            else if (d.length <= 12) cnpjInput.value = d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5, 8) + '/' + d.substring(8);
            else cnpjInput.value = d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5, 8) + '/' + d.substring(8, 12) + '-' + d.substring(12);
        });
    }

    // Data de nascimento: DD/MM/AAAA
    var birthInput = el('js-sg-birth');
    if (birthInput) {
        birthInput.addEventListener('input', function () {
            var d = onlyDigits(birthInput.value).substring(0, 8);
            if (d.length <= 2) birthInput.value = d;
            else if (d.length <= 4) birthInput.value = d.substring(0, 2) + '/' + d.substring(2);
            else birthInput.value = d.substring(0, 2) + '/' + d.substring(2, 4) + '/' + d.substring(4);
        });
    }

    // Telefone fixo: (XX) XXXX-XXXX — até 10 dígitos
    var phoneInput = el('js-sg-phone');
    if (phoneInput) {
        phoneInput.addEventListener('input', function () {
            var d = onlyDigits(phoneInput.value).substring(0, 10);
            if (d.length === 0)       { phoneInput.value = ''; return; }
            if (d.length <= 2)        { phoneInput.value = '(' + d; return; }
            if (d.length <= 6)        { phoneInput.value = '(' + d.substring(0, 2) + ') ' + d.substring(2); return; }
            phoneInput.value = '(' + d.substring(0, 2) + ') ' + d.substring(2, 6) + '-' + d.substring(6);
        });
    }

    // Celular: (XX) XXXXX-XXXX — até 11 dígitos
    var mobileInput = el('js-sg-mobile');
    if (mobileInput) {
        mobileInput.addEventListener('input', function () {
            var d = onlyDigits(mobileInput.value).substring(0, 11);
            if (d.length === 0)       { mobileInput.value = ''; return; }
            if (d.length <= 2)        { mobileInput.value = '(' + d; return; }
            if (d.length <= 7)        { mobileInput.value = '(' + d.substring(0, 2) + ') ' + d.substring(2); return; }
            mobileInput.value = '(' + d.substring(0, 2) + ') ' + d.substring(2, 7) + '-' + d.substring(7);
        });
    }

    // CEP: 00000-000
    var cepInput = el('js-sg-cep');
    if (cepInput) {
        cepInput.addEventListener('input', function () {
            var digits = onlyDigits(cepInput.value).substring(0, 8);
            cepInput.value = digits.length > 5 ? digits.substring(0, 5) + '-' + digits.substring(5) : digits;
        });
        cepInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                var btn = el('js-sg-cep-btn');
                if (btn) btn.click();
            }
        });
        // Busca automática ao sair do campo se CEP completo
        cepInput.addEventListener('blur', function () {
            var btn = el('js-sg-cep-btn');
            if (btn && !btn.disabled && onlyDigits(cepInput.value).length === 8) {
                btn.click();
            }
        });
    }

    /* ═══════════════════════════════════════════════════════
       FORÇA DA SENHA
    ═══════════════════════════════════════════════════════ */
    var PWD_CRITERIA = [
        { id: 'js-sg-req-len',     test: function (v) { return v.length >= 8; } },
        { id: 'js-sg-req-upper',   test: function (v) { return /[A-Z]/.test(v); } },
        { id: 'js-sg-req-lower',   test: function (v) { return /[a-z]/.test(v); } },
        { id: 'js-sg-req-num',     test: function (v) { return /[0-9]/.test(v); } },
        { id: 'js-sg-req-special', test: function (v) { return /[^A-Za-z0-9]/.test(v); } }
    ];

    function calcPasswordScore(val) {
        return PWD_CRITERIA.filter(function (c) { return c.test(val); }).length;
    }

    // Usada no cadastro via rede social: gera uma senha que já atende PWD_CRITERIA inteiro, pra
    // não obrigar quem veio do Google/Facebook a inventar (e lembrar) uma senha só pra loja.
    function generateStrongPassword() {
        var upper = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
        var lower = 'abcdefghijkmnpqrstuvwxyz';
        var digits = '23456789';
        var special = '!@#$%&*?';
        var all = upper + lower + digits + special;
        var cryptoObj = window.crypto || window.msCrypto;

        function randChar(charset) {
            var arr = new Uint32Array(1);
            cryptoObj.getRandomValues(arr);
            return charset[arr[0] % charset.length];
        }

        var chars = [randChar(upper), randChar(lower), randChar(digits), randChar(special)];
        for (var i = chars.length; i < 16; i++) chars.push(randChar(all));

        // Embaralha (Fisher-Yates) pra não deixar os 4 primeiros caracteres num padrão fixo
        for (var j = chars.length - 1; j > 0; j--) {
            var arr2 = new Uint32Array(1);
            cryptoObj.getRandomValues(arr2);
            var k = arr2[0] % (j + 1);
            var tmp = chars[j]; chars[j] = chars[k]; chars[k] = tmp;
        }

        return chars.join('');
    }

    function updatePasswordStrength() {
        var pwdEl = el('js-sg-password');
        var val = pwdEl ? pwdEl.value : '';
        var strengthEl = el('js-sg-pwd-strength');

        if (!val) {
            if (strengthEl) strengthEl.classList.add('hidden');
            return;
        }
        if (strengthEl) strengthEl.classList.remove('hidden');

        var score = 0;
        PWD_CRITERIA.forEach(function (c) {
            var met = c.test(val);
            var reqEl = el(c.id);
            if (reqEl) reqEl.classList.toggle('pwd-req--met', met);
            if (met) score++;
        });

        var pct = Math.round(score / PWD_CRITERIA.length * 100);
        var level, label;
        if (score <= 2)      { level = 'weak';   label = 'Fraca'; }
        else if (score <= 4) { level = 'medium'; label = 'Média'; }
        else                 { level = 'strong'; label = 'Forte'; }

        var fillEl = el('js-sg-pwd-fill');
        if (fillEl) {
            fillEl.style.width = pct + '%';
            fillEl.className = 'pwd-strength-fill pwd-strength-fill--' + level;
        }

        var labelEl = el('js-sg-pwd-label');
        if (labelEl) {
            labelEl.textContent = label;
            labelEl.className = 'pwd-strength-label pwd-strength-label--' + level;
        }
    }

    var pwdInputEl = el('js-sg-password');
    if (pwdInputEl) pwdInputEl.addEventListener('input', updatePasswordStrength);

    /* ═══════════════════════════════════════════════════════
       TOGGLE VISIBILIDADE DE SENHA
    ═══════════════════════════════════════════════════════ */
    var SVG_EYE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
    var SVG_EYE_OFF = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>';

    function attachPwdToggle(inputId, btnId) {
        var inp = el(inputId);
        var btn = el(btnId);
        if (!inp || !btn) return;
        btn.addEventListener('click', function () {
            var showing = inp.type === 'text';
            inp.type = showing ? 'password' : 'text';
            btn.innerHTML = showing ? SVG_EYE : SVG_EYE_OFF;
            btn.setAttribute('aria-label', showing ? 'Exibir senha' : 'Ocultar senha');
        });
    }

    attachPwdToggle('js-sg-password', 'js-sg-pwd-toggle');
    attachPwdToggle('js-sg-password-confirm', 'js-sg-pwd-confirm-toggle');

    /* ═══════════════════════════════════════════════════════
       BUSCA DE CEP (ViaCEP)
    ═══════════════════════════════════════════════════════ */
    var cepBtn = el('js-sg-cep-btn');
    if (cepBtn) {
        cepBtn.addEventListener('click', async function () {
            var cep = onlyDigits((cepInput || {}).value || '');
            var hintEl = el('js-sg-cep-hint');
            if (cep.length !== 8) {
                if (hintEl) hintEl.textContent = 'CEP inválido. Informe 8 dígitos.';
                return;
            }
            if (hintEl) hintEl.textContent = 'Buscando...';
            cepBtn.disabled = true;
            try {
                var resp = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
                var result = await resp.json();
                if (result.erro) {
                    if (hintEl) hintEl.textContent = 'CEP não encontrado.';
                } else {
                    setValue('js-sg-street', result.logradouro || '');
                    setValue('js-sg-neighborhood', result.bairro || '');
                    setValue('js-sg-city', result.localidade || '');
                    setValue('js-sg-state', result.uf || '');
                    if (hintEl) hintEl.textContent = '';
                    var numInput = el('js-sg-number');
                    if (numInput) numInput.focus();
                }
            } catch (e) {
                if (hintEl) hintEl.textContent = 'Erro ao buscar CEP. Preencha manualmente.';
            }
            cepBtn.disabled = false;
        });
    }

    /* ═══════════════════════════════════════════════════════
       BLUR — CHECK-SIGNUP (e-mail, CPF, CNPJ)
    ═══════════════════════════════════════════════════════ */
    // O blur e o botão Próximo compartilham a consulta em andamento.
    // Respostas de valores que já foram editados nunca alteram o campo atual.
    var fieldChecks = {};

    function attachCheckBlur(inputId, iconId, msgId, getCheckBody, minLength) {
        var inp = el(inputId);
        if (!inp) return;
        var checkedValue = null;
        var checkedResult = null;
        var pending = null;
        var revision = 0;

        // Ao editar, reseta estado e visual para forçar nova verificação
        inp.addEventListener('input', function () {
            setFieldCheck(inputId, iconId, msgId, 'reset', '');
            checkedValue = null;
            checkedResult = null;
            pending = null;
            revision++;
        });

        fieldChecks[inputId] = async function () {
            var digits = onlyDigits(inp.value);
            var raw = inp.value.trim();
            if ((minLength === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(raw)) ||
                (typeof minLength === 'number' && digits.length !== minLength)) {
                return false;
            }
            var resultKey = minLength === 'email' ? 'email' : 'cpf_cnpj';
            if (checkedValue === raw && checkedResult) {
                applyCheckResult(resultKey, checkedResult, inputId, iconId, msgId);
                return !!(checkedResult.valid && !checkedResult.exists);
            }
            if (pending && pending.value === raw) return pending.promise;
            var requestRevision = revision;
            var request = { value: raw };
            request.promise = Promise.resolve().then(async function () {
                try {
                    var data = await ApiWS.Calls.checkSignup(getCheckBody(raw, digits));
                    if (revision !== requestRevision || inp.value.trim() !== raw) return false;
                    var result = data && data.record && data.record[resultKey];
                    if (!result) throw new Error('Resposta de validação indisponível');
                    checkedValue = raw;
                    checkedResult = result;
                    applyCheckResult(resultKey, result, inputId, iconId, msgId);
                    return !!(result.valid && !result.exists);
                } catch (e) {
                    if (revision === requestRevision && inp.value.trim() === raw) {
                        setFieldError(inputId, 'Não foi possível validar este campo. Tente novamente.');
                    }
                    return false;
                } finally {
                    if (pending === request) pending = null;
                }
            });
            pending = request;
            return request.promise;
        };
        inp.addEventListener('blur', function () { fieldChecks[inputId](); });
    }

    attachCheckBlur(
        'js-sg-email', 'js-sg-email-icon', 'js-sg-email-vmsg',
        function (raw) { return { email: raw }; },
        'email'
    );
    attachCheckBlur(
        'js-sg-cpf', 'js-sg-cpf-icon', 'js-sg-cpf-vmsg',
        function (raw, digits) { return { cpf_cnpj: digits }; },
        11
    );
    attachCheckBlur(
        'js-sg-cnpj', 'js-sg-cnpj-icon', 'js-sg-cnpj-vmsg',
        function (raw, digits) { return { cpf_cnpj: digits }; },
        14
    );

    /* ═══════════════════════════════════════════════════════
       NAVEGAÇÃO ENTRE ETAPAS
    ═══════════════════════════════════════════════════════ */
    var step1El = el('js-signup-step1');
    var step2El = el('js-signup-step2');

    function showStep(n) {
        if (step1El) step1El.classList.toggle('hidden', n !== 1);
        if (step2El) step2El.classList.toggle('hidden', n !== 2);
        var step3El = el('js-signup-step3');
        if (step3El) step3El.classList.toggle('hidden', n !== 3);

        var ind1 = el('js-step-ind-1');
        var ind2 = el('js-step-ind-2');
        var ind3 = el('js-step-ind-3');
        var num1 = el('js-step-num-1');
        var num2 = el('js-step-num-2');

        [ind1, ind2, ind3].forEach(function (ind) { if (ind) ind.classList.remove('active', 'done'); });
        if (num1) num1.textContent = '1';
        if (num2) num2.textContent = '2';

        if (n === 1) {
            if (ind1) ind1.classList.add('active');
        } else if (n === 2) {
            if (ind1) ind1.classList.add('done');
            if (ind2) ind2.classList.add('active');
            if (num1) num1.textContent = '✓';
        } else {
            if (ind1) ind1.classList.add('done');
            if (ind2) ind2.classList.add('done');
            if (ind3) ind3.classList.add('active');
            if (num1) num1.textContent = '✓';
            if (num2) num2.textContent = '✓';
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /* ═══════════════════════════════════════════════════════
       VALIDAÇÃO ETAPA 1
    ═══════════════════════════════════════════════════════ */
    function fieldValue(id) {
        return ((el(id) || {}).value || '').trim();
    }

    function step1Snapshot() {
        return JSON.stringify(Array.from(step1El.querySelectorAll('input, select')).map(function (inp) {
            return [inp.id, inp.value, inp.checked];
        }));
    }

    function isValidBirthDate(value) {
        if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false;
        var parts = value.split('/').map(Number);
        var date = new Date(parts[2], parts[1] - 1, parts[0]);
        return date.getFullYear() === parts[2] && date.getMonth() === parts[1] - 1 &&
            date.getDate() === parts[0] && date <= new Date();
    }

    async function validateStep1() {
        var valid = true;
        var checks = [];
        step1El.querySelectorAll('.field-input--error').forEach(clearFieldError);
        function requireField(id, condition, message) {
            if (!condition) {
                setFieldError(id, message);
                valid = false;
            }
            return condition;
        }

        requireField('js-sg-name', !!fieldValue('js-sg-name'), 'Informe seu nome completo.');
        if (requireField('js-sg-email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue('js-sg-email')), 'Informe um e-mail válido.')) {
            checks.push(fieldChecks['js-sg-email']());
        }

        var password = (el('js-sg-password') || {}).value || '';
        var confirm = (el('js-sg-password-confirm') || {}).value || '';
        requireField('js-sg-password', !!password && calcPasswordScore(password) === PWD_CRITERIA.length,
            password ? 'Crie uma senha forte: atenda a todos os requisitos indicados abaixo do campo.' : 'Informe uma senha.');
        if (password && calcPasswordScore(password) < PWD_CRITERIA.length) updatePasswordStrength();
        requireField('js-sg-password-confirm', !!confirm && password === confirm,
            confirm ? 'As senhas não coincidem.' : 'Confirme sua senha.');

        var isF = typeF && typeF.checked;
        var documentId = isF ? 'js-sg-cpf' : 'js-sg-cnpj';
        if (!isF) requireField('js-sg-razao', !!fieldValue('js-sg-razao'), 'Informe a razão social.');
        if (requireField(documentId, onlyDigits(fieldValue(documentId)).length === (isF ? 11 : 14),
            isF ? 'Informe um CPF válido.' : 'Informe um CNPJ válido.')) {
            checks.push(fieldChecks[documentId]());
        }

        requireField('js-sg-birth', isValidBirthDate(fieldValue('js-sg-birth')), 'Informe uma data de nascimento válida (DD/MM/AAAA).');
        requireField('js-sg-gender', !!fieldValue('js-sg-gender'), 'Selecione o sexo.');
        var phone = onlyDigits(fieldValue('js-sg-phone'));
        requireField('js-sg-phone', !fieldValue('js-sg-phone') || phone.length === 10, 'Informe o telefone com DDD.');
        var mobile = onlyDigits(fieldValue('js-sg-mobile'));
        requireField('js-sg-mobile', mobile.length >= 10 && mobile.length <= 11, 'Informe o celular com DDD.');

        // As consultas são iniciadas mesmo quando outros campos têm erros.
        var results = await Promise.all(checks);
        return valid && results.every(function (result) { return result; });
    }

    var nextBtn = el('js-sg-next-btn');
    if (nextBtn) {
        nextBtn.addEventListener('click', async function () {
            if (nextBtn.disabled) return;
            clearMsg('js-sg-msg1');
            var snapshot = step1Snapshot();
            setLoading('js-sg-next-btn', true);
            try {
                var valid = await validateStep1();
                if (valid && snapshot === step1Snapshot()) showStep(2);
                else focusFirstError(step1El);
            } finally {
                setLoading('js-sg-next-btn', false);
            }
        });
    }

    var backBtn = el('js-sg-back-btn');
    if (backBtn) {
        backBtn.addEventListener('click', function () {
            clearMsg('js-sg-msg2');
            showStep(1);
        });
    }

    /* ═══════════════════════════════════════════════════════
       SUBMISSÃO (ETAPA 2 → API)
    ═══════════════════════════════════════════════════════ */
    var submitBtn = el('js-sg-submit-btn');
    if (submitBtn) {
        submitBtn.addEventListener('click', async function () {
            clearMsg('js-sg-msg2');

            // Valida etapa 2
            var zip = onlyDigits((cepInput || {}).value || '');
            var street = ((el('js-sg-street') || {}).value || '').trim();
            var number = ((el('js-sg-number') || {}).value || '').trim();
            var neighborhood = ((el('js-sg-neighborhood') || {}).value || '').trim();
            var city = ((el('js-sg-city') || {}).value || '').trim();
            var state = ((el('js-sg-state') || {}).value || '').trim().toUpperCase();

            step2El.querySelectorAll('.field-input--error').forEach(clearFieldError);
            var addressChecks = [
                ['js-sg-cep', zip.length === 8, 'Informe um CEP válido (8 dígitos).'],
                ['js-sg-street', !!street, 'Informe o endereço.'],
                ['js-sg-number', !!number, 'Informe o número.'],
                ['js-sg-neighborhood', !!neighborhood, 'Informe o bairro.'],
                ['js-sg-city', !!city, 'Informe a cidade.'],
                ['js-sg-state', /^[A-Z]{2}$/.test(state), 'Informe o estado (UF) com 2 letras.']
            ];
            addressChecks.forEach(function (check) {
                if (!check[1]) setFieldError(check[0], check[2]);
            });
            if (addressChecks.some(function (check) { return !check[1]; })) {
                focusFirstError(step2El);
                return;
            }

            // Monta body
            var isF = typeF && typeF.checked;
            var personType = isF ? 'F' : 'J';
            var nomeCompleto = ((el('js-sg-name') || {}).value || '').trim();
            var cpfCnpj = onlyDigits(isF ? ((el('js-sg-cpf') || {}).value || '') : ((el('js-sg-cnpj') || {}).value || ''));
            var birthRaw = (el('js-sg-birth') || {}).value || '';
            var birthDate = parseDateInput(birthRaw);
            var gender = (el('js-sg-gender') || {}).value || '';
            var phone = onlyDigits((el('js-sg-phone') || {}).value || '');
            var mobile = onlyDigits((el('js-sg-mobile') || {}).value || '');
            var newsletter = !!(el('js-sg-newsletter') || {}).checked;
            var howRaw = (el('js-sg-how') || {}).value || '';
            var complement = ((el('js-sg-complement') || {}).value || '').trim();

            // PF: name = nome completo
            // PJ: name = razão social, contact = nome completo do responsável
            var bodyName = isF
                ? nomeCompleto
                : ((el('js-sg-razao') || {}).value || '').trim();

            var body = {
                name: bodyName,
                email: ((el('js-sg-email') || {}).value || '').trim(),
                password: (el('js-sg-password') || {}).value || '',
                person_type: personType,
                cpf_cnpj: cpfCnpj,
                newsletter: newsletter,
                zip_code: zip,
                address: street,
                address_number: number,
                neighborhood: neighborhood,
                city: city,
                state: state
            };

            // Para PJ, nome completo do responsável vai como "contact"
            if (!isF && nomeCompleto) body.contact = nomeCompleto;

            // Campos opcionais — só inclui se preenchidos
            if (birthDate) body.birth_date = birthDate;
            if (gender) body.gender = gender;
            if (phone) body.phone = phone;
            if (mobile) body.mobile = mobile;
            if (complement) body.complement = complement;
            if (howRaw) body.how_did_you_know = parseInt(howRaw, 10);
            if (_signupProfileId) body.profile_id = _signupProfileId;

            setLoading('js-sg-submit-btn', true);
            try {
                var data = await ApiWS.Calls.signup(body);

                if (data && data.result === 'success') {
                    ApiWS.User.saveSession(data.record);
                    if (typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
                        ApiWS.CustomerEmail.set(
                            (data.record && data.record.customer && data.record.customer.email) || body.email,
                            { source: 'signup', authoritative: true }
                        );
                    }

                    var isPending = !!(_signupProfileId && window.__WS_SIGNUP_PROFILE__ && window.__WS_SIGNUP_PROFILE__.wait_for_approval);
                    var conclusionSuccess = el('js-sg-conclusion-success');
                    var conclusionPending = el('js-sg-conclusion-pending');
                    if (isPending) {
                        if (conclusionSuccess) conclusionSuccess.classList.add('hidden');
                        if (conclusionPending) conclusionPending.classList.remove('hidden');
                    } else {
                        if (conclusionSuccess) conclusionSuccess.classList.remove('hidden');
                        if (conclusionPending) conclusionPending.classList.add('hidden');
                    }

                    setLoading('js-sg-submit-btn', false);
                    showStep(3);

                    // Se veio de ?return_to= (ex: checkout), redireciona após breve confirmação
                    var returnTo = getReturnTo();
                    if (returnTo && !isPending) {
                        setTimeout(function () { window.location.href = returnTo; }, 2000);
                    }
                } else {
                    setMsg('js-sg-msg2', (data && data.message) || 'Erro ao criar cadastro. Tente novamente.', 'error');
                    setLoading('js-sg-submit-btn', false);
                }
            } catch (e) {
                setMsg('js-sg-msg2', 'Erro de conexão. Tente novamente.', 'error');
                setLoading('js-sg-submit-btn', false);
            }
        });
    }

    /* ═══════════════════════════════════════════════════════
       COMO NOS CONHECEU — carrega opções da API
    ═══════════════════════════════════════════════════════ */
    async function loadHowDidYouFindUs() {
        try {
            var data = await ApiWS.Calls._get('/store/info');
            var options = (data && data.how_did_you_find_us) || [];
            if (options.length === 0) return;

            var sel = el('js-sg-how');
            var wrap = el('js-sg-how-wrap');
            if (!sel) return;

            options.forEach(function (opt) {
                var o = document.createElement('option');
                o.value = opt.id;
                o.textContent = opt.label;
                sel.appendChild(o);
            });

            if (wrap) wrap.classList.remove('hidden');
        } catch (e) {}
    }

    /* ═══════════════════════════════════════════════════════
       INICIALIZAÇÃO
    ═══════════════════════════════════════════════════════ */

    // Retorna ao checkout (ou outra página) após login/cadastro
    function getReturnTo() {
        try {
            var val = new URLSearchParams(window.location.search).get('return_to') || '';
            return val && val.startsWith('/') ? val : '';
        } catch (e) { return ''; }
    }

    // Redireciona se já logado
    if (typeof ApiWS !== 'undefined' && ApiWS.User && ApiWS.User.isValid()) {
        window.location.href = getReturnTo() || '/minha-conta';
    }

    // Carrega opções de "Como nos conheceu" da API
    if (typeof ApiWS !== 'undefined' && ApiWS.Calls) {
        loadHowDidYouFindUs();
    }

    // Preenche âncoras do perfil (ex: data-ws-signup-info="profile.name") e guarda profile_id
    (function () {
        try {
            var profile = window.__WS_SIGNUP_PROFILE__;
            if (!profile) return;
            _signupProfileId = profile.profile_id || null;
            document.querySelectorAll('[data-ws-signup-info]').forEach(function (anchor) {
                var key = anchor.getAttribute('data-ws-signup-info');
                if (key === 'profile.name' && profile.profile_name) {
                    anchor.textContent = profile.profile_name;
                }
            });
        } catch (e) {}
    })();

    // Pré-preenche nome se passado por query string (ex: vindo do cadastro com Google/Facebook)
    (function () {
        try {
            var nameParam = new URLSearchParams(window.location.search).get('name');
            if (nameParam) setValue('js-sg-name', nameParam);
        } catch (e) {}
    })();

    // Pré-preenche e-mail se passado por query string e já dispara check-signup.
    // Sem query string, cai no e-mail conhecido do visitante (ApiWS.CustomerEmail),
    // alimentado por login/identificação/newsletter/contato anteriores.
    (function () {
        try {
            var params = new URLSearchParams(window.location.search);
            var emailParam = params.get('email');
            if (!emailParam && typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
                emailParam = ApiWS.CustomerEmail.get();
            }
            if (!emailParam) return;

            setValue('js-sg-email', emailParam);

            // Usa a mesma consulta do blur/Próximo, inclusive se ainda estiver pendente.
            if (typeof ApiWS !== 'undefined' && ApiWS.Calls) fieldChecks['js-sg-email']();
        } catch (e) {}
    })();

    // Cadastro via rede social (?social=google|facebook, setado por /cadastro-pass): não faz
    // sentido pedir uma senha de quem acabou de autenticar com o provedor — oculta o campo e já
    // gera uma senha forte por baixo dos panos, mantendo o restante do fluxo de validação/submit
    // inalterado (validateStep1 e o body do POST continuam lendo os mesmos inputs normalmente).
    (function () {
        try {
            var social = new URLSearchParams(window.location.search).get('social');
            if (!social) return;

            var pwd = generateStrongPassword();
            setValue('js-sg-password', pwd);
            setValue('js-sg-password-confirm', pwd);

            var row = el('js-sg-password-row');
            if (row) row.classList.add('hidden');

            var note = el('js-sg-password-social-note');
            if (note) note.classList.remove('hidden');
        } catch (e) {}
    })();

})();
